module.exports = __webpack_public_path__ + "static/FY_2023_Financial_Reporting_Audit_Report-9fadace8fd6774e7cd1b01b417414d5d.pdf";